import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {FormattedMessage, useIntl} from 'react-intl';

import {IStore} from 'redux/interface';
import {
  cmServiceAsyncActions,
  getCmFilters,
  getCmServices,
  getTranslations
} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {TranslationKeys} from 'utils/constants/routeConstants';

import NotFoundImg from 'assets/image/common/notFound.png';
import {ReactComponent as BookIcon} from 'assets/image/library/book.svg';

import Loader from 'components/loader';
import NotFoundInfo from 'components/not-found-info';
import {ICmFilter} from '../../redux/cm-service/interfaces';
import {CmResourceFilters} from '../../components/cm-filters/CmResourceFilters';
import {maxServiceCards} from '../../utils/constants/constants';
import CmCardSection from '../../components/cm-card-section';
import {useNavigate} from 'react-router-dom';

import './styles.scss';

export const CmResource: React.FunctionComponent = () => {
  const {
    services,
    filters,
    page
  } = useSelector((state: IStore) => state.cm_service);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const dispatch = useDispatch();
  const intl = useIntl();
  const [selectedFilters, setSelectedFilters] = useState<ICmFilter[]>([]);
  const history = useNavigate();

  useGetTranslations({
    translationKey: TranslationKeys.CmResource
  });

  useEffect(() => {
    dispatch(cmServiceAsyncActions[getCmFilters]());
  }, []);

  function loadService({
    filter,
    offset
  }: { filter: ICmFilter[]; offset: number }) {
    const filtersWithValue = filter.filter(f => f.inputValue);

    dispatch(cmServiceAsyncActions[getCmServices](
      {
        filter: filtersWithValue,
        offset,
        limit: maxServiceCards
      }
    ));
  }

  useEffect(() => {
    loadService({filter: [], offset: 0});
  }, []);

  function handleLoadMore(offset: number) {
    loadService({
      filter: selectedFilters,
      offset
    });
  }

  function handleChangeFilters(changedFilters: ICmFilter[]) {
    setSelectedFilters(changedFilters);
    loadService({
      filter: changedFilters,
      offset: 0
    });
  }

  function handleOpenCard(srvId: number) {
    history(`/cmresource/${srvId}`);
  }

  function renderFilters() {
    if (filters) {
      return <CmResourceFilters filters={filters} onChange={handleChangeFilters}/>;
    }

    return null;
  }

  return <section className={'cm-resource container'}>
    {
      !loading.includes(getTranslations) && <>
        <h1 className="cm-resource__title"><BookIcon className="cm-resource__icon"/>
          <FormattedMessage
            id={'gritx.cmresource.title'}
            defaultMessage={'Resources'}
          />
        </h1>
        <div className="cm-resource__filters">
          {
            loading.includes(getCmFilters) ? <Loader/> : renderFilters()
          }
        </div>
        <div className="cm-resource__cards">
          {services.length === 0 && filters && !loading.includes(getCmServices) ? <NotFoundInfo
            title={intl.formatMessage({
              id: 'gritx.cmresource.sectionCards.notFound',
              defaultMessage: 'Sorry, but nothing can be found. Try the search or apply fewer filters.'
            })}
            image={NotFoundImg}
          /> : page && <CmCardSection
            showLoader={loading.includes(getCmServices)}
            cards={services}
            onLoadMore={handleLoadMore}
            onClickCard={handleOpenCard}
            page={page}
          />}
        </div>
      </>
    }
  </section>;
};
